module.exports = __webpack_public_path__ + "static_pc/img/26.e7c4cb57.png";